import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { Modal, Button, Input, Form, message } from 'antd';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import { uploadFiles } from "../Api/filesApi";
import pica from 'pica';

const resizeImage = async (imageBlob) => {
    const offscreenCanvas = document.createElement('canvas');
    offscreenCanvas.width = 1024; // target width
    offscreenCanvas.height = 768; // target height

    const img = new Image();
    img.src = URL.createObjectURL(imageBlob);
    await img.decode();

    const result = await pica().resize(img, offscreenCanvas, {
        unsharpAmount: 80,
        unsharpRadius: 0.6,
        unsharpThreshold: 2
    });

    return new Promise((resolve, reject) => {
        result.toBlob((blob) => {
            resolve(blob);
        }, 'image/png');
    });
};


const Screenshot = ({ image, onUpload }) => {
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [imageName, setImageName] = useState('');

    const handleCancel = () => setIsModalVisible(false);

    const handleNameChange = (e) => setImageName(e.target.value);

    const handleSubmit = async () => {
        if (!imageName) {
            message.error('Please provide a name for the screenshot.');
            return;
        }

        // Convert base64 to File object with MIME type and filename
        const base64Response = await fetch(image);
        const blob = await base64Response.blob();
        const filename = `${createFileName(imageName)}.png`.slice(1, ).toString();
        console.log('FILENAME', filename);

        const file = new File([blob], filename, { type: 'image/png' });

        dispatch(uploadFiles({ files: [{ originFileObj: file }], folderPath: 'images' })).then((response) => {
            console.log(response);
            message.success('Screenshot uploaded successfully!');
        }).catch((error) => {
            message.error('Upload failed: ' + error);
        });
    };

    return (
        <Modal
            title="Save and Upload Screenshot"
            open={isModalVisible}
            destroyOnClose={true}
            onCancel={handleCancel}
            width={800}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Upload Screenshot
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item label="Screenshot Name">
                    <Input placeholder="Enter a name for your screenshot" value={imageName} onChange={handleNameChange} />
                </Form.Item>
                {image && <img src={image} alt="Screenshot" style={{ maxWidth: '100%' }} />}
            </Form>
        </Modal>
    );
};

export default Screenshot;
